// Получение initData и метаданных Telegram WebApp.
// Используется минимальный подход через window.Telegram.WebApp — это работает без проблем
// и не зависит от мажорных версий @telegram-apps/sdk-react.

interface TgWebApp {
  initData: string
  initDataUnsafe?: {
    user?: { id: number; first_name?: string; last_name?: string; username?: string }
  }
  colorScheme?: 'light' | 'dark'
  themeParams?: Record<string, string>
  ready: () => void
  expand: () => void
  close: () => void
  BackButton: {
    show: () => void
    hide: () => void
    onClick: (cb: () => void) => void
    offClick: (cb: () => void) => void
  }
  MainButton: {
    text: string
    show: () => void
    hide: () => void
    enable: () => void
    disable: () => void
    setText: (t: string) => void
    onClick: (cb: () => void) => void
    offClick: (cb: () => void) => void
  }
  HapticFeedback?: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void
    notificationOccurred: (type: 'error' | 'success' | 'warning') => void
    selectionChanged: () => void
  }
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TgWebApp }
  }
}

export function getWebApp(): TgWebApp | null {
  return window.Telegram?.WebApp ?? null
}

export function getInitData(): string {
  // Для разработки в браузере без Telegram можно подложить тестовое значение через URL
  const wa = getWebApp()
  if (wa?.initData) return wa.initData
  // Dev fallback: ?initData=...
  const params = new URLSearchParams(window.location.search)
  return params.get('initData') ?? ''
}

export function hapticImpact(style: 'light' | 'medium' | 'heavy' = 'light') {
  getWebApp()?.HapticFeedback?.impactOccurred(style)
}

export function hapticSuccess() {
  getWebApp()?.HapticFeedback?.notificationOccurred('success')
}

export function hapticError() {
  getWebApp()?.HapticFeedback?.notificationOccurred('error')
}

export function hapticSelection() {
  getWebApp()?.HapticFeedback?.selectionChanged()
}

export function initTelegram() {
  const wa = getWebApp()
  if (wa) {
    wa.ready()
    wa.expand()
  }
}
